import React, {useEffect, useState} from "react";
import SectionContentBox from "../SectionContentBox";
import apiService from "../../services/apiService";
import {useLanguage} from "../../hooks/LanguageContext";


const OurPartner = () => {
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const [data, setData] = useState([]);
	const {direction} = useLanguage();

	useEffect(() => {
		apiService
			.getPartners()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {

			});
	}, []);
	return (
		<section className='container '>
			<div className=' mt-[100px]'>
				<SectionContentBox
					justify='justify-center'
					width='md:w-[296px] w-full mx-auto md:mb-[50px]'
					align={"items-center"}
					title={direction === "ltr" ? "Our Partners" : "شركاؤنا"}
					hasTowLines={true}
					headline={
						<>
							{direction === "ltr"? "Strength in" : "القوة في"}{" "}
							<span className="text-primary-700">
                {direction === "ltr" ? "Cooperation" : "التعاون"}
              </span>
						</>
					}
					paragraph={
						direction === "ltr"
							? "We are honored to cooperate with"
							: "نتشرف بالتعاون مع كل من"
					}
					hideBtn={true}
				/>

				<div className='mx-auto max-w-[70%]    flex items-center justify-center md:gap-[80px] gap-8 flex-wrap '>
					{data.map((item) => (
						<div key={item.id} className=' flex items-center justify-center'>
							<img
								className="md:w-auto w-[80px] md:h-[110px] h-[75px]"
								src={`${baseUrl}/${item.image}`}
								alt={item.name_en + "-icon"}
							/>
						</div>

					))}
				</div>
			</div>
		</section>
	);
};

export default OurPartner;
